import React from 'react';
import { CdnImage } from 'src/components/cdn-image';
import {
  StyledShopCard,
  ShopButton,
  LogoWrapper,
  CallToActionText,
} from './styles';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const ShopCard: React.FC<IShopCardProps> = ({
  id,
  name,
  width,
  height,
  logo,
  hasLogo = false,
  featured = false,
  onClick = noop,
  callToActionText,
}) => (
  <StyledShopCard>
    <ShopButton type="button" onClick={onClick} style={{ width, height }}>
      {hasLogo && id ? (
        <CdnImage name={id} width={width} />
      ) : (
        <LogoWrapper>
          {logo && featured ? <img alt={name} src={logo} /> : name}
        </LogoWrapper>
      )}
      {callToActionText && (
        <CallToActionText>{callToActionText}</CallToActionText>
      )}
    </ShopButton>
  </StyledShopCard>
);

interface IShopCardProps {
  id?: number;
  name: string;
  width?: number;
  height?: number;
  logo?: string;
  hasLogo?: boolean;
  featured?: boolean;
  onClick?: () => void;
  callToActionText?: string;
}
